import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {UserRequestDetailComponent} from "../user-request-detail/user-request-detail.component";

import {DynamicModalFormComponent} from "../../../common/dynamic-modal-form/dynamic-modal-form.component";
import {
  UserRequestComparatorComponent
} from "../../../common/user-request-comparator/user-request-comparator.component";
import {UserRequest} from "../../../../model/UserRequest";
import {FaqCategory} from "../../../../model/FaqCategory";
import {RejectRequestFormGeneratorService} from "../../../../formulaires/admin/reject-request-form-generator.service";

@Component({
    selector: 'app-user-requests-reject',
    imports: [
    DynamicModalFormComponent,
    FaIconComponent,
    UserRequestComparatorComponent,
    UserRequestDetailComponent
],
    templateUrl: './user-requests-reject.component.html',
    styleUrl: './user-requests-reject.component.scss'
})
export class UserRequestsRejectComponent {
  @Input()
  request: UserRequest;
  @Input()
  crmUrl: string;
  @Input()
  categories: FaqCategory[] = [];

  @Output()
  submit = new EventEmitter();
  @Output()
  cancel = new EventEmitter();

  constructor(public rejectRequestFormGeneratorService: RejectRequestFormGeneratorService) {
  }

  onSubmit($event): void {
    this.submit.emit($event);
  }

  onCancel() {
    this.cancel.emit();
  }
}
